import { LOCALES_URL } from "../resources/ApiUrls";
import MyAxiosInstance from "../utils/MyAxiosInstance";

const getAll = () => MyAxiosInstance.get(LOCALES_URL);

const exports = {
  getAll,
}
export default exports
